import React, { useState, useEffect } from 'react'
import { Modal as BModal, Card } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { ClipLoader } from 'react-spinners'

export function Popup(props) {
  const [html, setHtml ] = useState("")
  const [ loading, setLoading ] = useState(true)
  const dispatch = useDispatch()
  const { url } = useSelector(state=>state.popUp)

  useEffect(() => {
    if (!!url){
      setLoading(true)
      $.ajax({
        url,
        success: response => {
          setHtml(response)
          setLoading(false)
        }
      })
    } else {
      setHtml("")
    }
  }, [url])

  function handleClose(){
    dispatch({type: "CLEAR_POPUP"})
  }
  return(
    <BModal size={'md'} show={!!url} onHide={handleClose}>
      {
        loading ?
        <div className="p-5 w-100 h-100 bg-danger d-flex justify-content-center"><ClipLoader/></div> :
        <div dangerouslySetInnerHTML={{__html: html}}/> 
      }
    </BModal>
  )
}

export default Popup